export class setWidthParams {
    days: number;
    cellWidth: number;
    constructor(days,cellWidth) {
        this.days = days;
        this.cellWidth =  cellWidth;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/info-expense/set-width-params.ts